/* 孫吳傳・第 16 章：濡須・百騎劫營（建安十八年，213）
 * 史實：《甘寧傳》注引《江表傳》：甘寧「選手下健兒百餘人，徑詣曹公營下，使拔鹿角，踰壘入營，斬得數十級。
 *       北軍驚駭鼓譟，舉火如星，寧已還入營，作鼓吹，稱萬歲」。
 * 流程：操作甘寧帶百騎（十名健兒代表）夜行到曹營，站著拔掉營門的鹿角（讀條）→ 入營斬殺熟睡的曹兵；
 *       巡營的兵看到你、殺得越多，營中的「警戒」越高，滿了就全營驚醒、舉火如星 → 撤回濡須塢即結束。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, TROOPS, rout } from '../kit.ts';
import { CAMP, DOORS, WU } from '../maps/ruxu.ts';

const LV = 13, GOAL = 20;
const FOE = { spec: TROOPS.wei, name: '曹兵', hp: 300, maxHp: 300, atk: 26 };

export default {
  id: 'sunwu-16', map: 'ruxu', hero: 'ganning',
  title: '第 14 章　濡須・百騎劫營', year: '建安十八年（213）',
  brief: {
    quote: [{ text: '選手下健兒百餘人，徑詣曹公營下，使拔鹿角，踰壘入營，斬得數十級。', src: '《甘寧傳》注引《江表傳》' }],
    text: '曹操率大軍進攻濡須口。孫權給甘寧米酒，讓他帶百餘人夜襲曹營。甘寧先自己飲了一碗，再一一斟給部下。',
    goals: ['拔掉營門的鹿角', `入營斬首 ${GOAL} 級`, '撤回濡須塢'],
  },
  words: { ally: '健兒', foe: '曹兵' },
  stars: [
    { text: `斬首 ${GOAL} 級以上`, ok: (m) => m.vars.kills >= GOAL },
    { text: '十名健兒全數回營', ok: (m) => m.stats.lost === 0 }, // 「百騎無一傷亡」是演義第 68 回，不算如史
    { text: '全營驚醒前就撤出營外', ok: (m) => !!m.vars.outFirst },
  ],
  steps: [
    { // 1. 夜行到營下，拔鹿角
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = WU[0]; me.y = WU[1] - 300;
        V.kills = 0; V.alert = 0;
        V.men = Array.from({ length: 10 }, (_, i) => { const u = m.recruit(me.x - 100 - (i % 5) * 45, me.y + 60 + Math.floor(i / 5) * 70, '健兒'); u.hp = u.maxHp = 560; u.atk = 26; m.join(u, me); return u; });
        DOORS.forEach(([x, y], i) => { m.gate('door' + i, x, y, 130, 'abatis'); m.mark('d' + i, x, y + 90, '鹿角', true); });
        // 營裡：睡著的曹兵（帳篷之間），加上巡營的兵
        V.sleep = [];
        for (let i = 0; i < 40; i++) {
          const a = SG.rand() * Math.PI * 2, d = 150 + SG.rand() * 800, x = CAMP.x + Math.cos(a) * d, y = CAMP.y - 50 + Math.sin(a) * d * 0.5;
          const u = m.foe('huangjin', x, y, FOE); u.asleep = true; V.sleep.push(u);
        }
        V.watch = [[2800, 1700], [4200, 1700], [3500, 1200], [3500, 1950]].map(([x, y]) => { const u = m.foe('huangjin', x, y, Object.assign({}, FOE, { name: '巡營兵' })); m.patrol(u, [[x - 300, y], [x + 300, y]]); return u; });
        m.line('旁白', '孫權賜甘寧米酒。甘寧先自己飲了，再一一斟給部下。');
        m.line('甘寧', '今夜就去曹營，取他幾十顆首級回來！');
        m.after(4, () => m.line('提示', '站在營門的鹿角旁不動，就能拔掉。進營後，被巡營的兵看到、殺得越多，警戒就越高。'));
        m.obj('door', '拔掉營門的鹿角');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        DOORS.forEach(([x, y], i) => { if (m.gates.some((g) => g.id === 'door' + i)) m.chanAt(me, 'door' + i, x, y + 80, 160, 3, '拔鹿角', () => { m.ungate('door' + i); m.unmark('d' + i); V.open = true; }); });
        return !!V.open;
      },
    },
    { // 2. 踰壘入營：斬首
      enter(m) {
        m.done('door');
        m.line('甘寧', '鹿角拔了！進營！');
        m.obj('kill', `斬首（${GOAL} 級）`, GOAL);
        m.obj('alert', '曹營的警戒：0%');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        m.prog('kill', V.kills);
        if (V.kills >= GOAL && !V.enough) { V.enough = true; m.line('甘寧', '首級夠了！撤！'); m.mark('wu', WU[0], WU[1], '濡須塢'); }
        if (V.alert >= 100) return true;
        if (V.enough && me.y > CAMP.y + CAMP.hh + 200) { V.outFirst = true; return true; }
        return false;
      },
    },
    { // 3. 北軍驚駭鼓譟，舉火如星：撤回
      enter(m, w) {
        const V = m.vars;
        m.mark('wu', WU[0], WU[1], '濡須塢');
        m.obj('back', '撤回濡須塢');
        if (V.alert >= 100) {
          m.big('全營驚醒！');
          m.card('北軍驚駭鼓譟，舉火如星。', '《江表傳》');
          for (const u of V.sleep) if (u.alive) u.asleep = false;
          V.chase = Array.from({ length: 12 }, (_, i) => m.foe('huangjin', CAMP.x - 500 + (i % 6) * 200, CAMP.y - 400, Object.assign({}, FOE, { ms: 250 })));
        }
      },
      tick(m, w) {
        if (!m.near(w.player, WU[0], WU[1], 380)) return false;
        const V = m.vars;
        m.done('back'); m.unmark('wu');
        rout(m, w, (V.chase || []).concat(V.sleep, V.watch), [CAMP.x, CAMP.y - 400]);
        m.card('寧已還入營，作鼓吹，稱萬歲。', '《江表傳》');
        m.after(3, () => m.line('孫權', '孟德有張遼，孤有興霸，足相敵也！'));
        m.after(7, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w, dt) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('甘寧陣亡'); return; }
    if (!V.sleep) return;
    // 睡著的：不會找人打；挨了打、或全營驚醒才醒來
    let kills = 0;
    for (const u of V.sleep) {
      if (!u.alive) { kills++; if (!u.killedAt) { u.killedAt = w.t; if (m.i >= 1) V.alert += 2; } continue; }
      if (u.asleep && u.hp < u.maxHp) { u.asleep = false; u.wokeAt = w.t; }
      if (u.asleep) { u.target = null; u.think = 0.5; u.home = [u.x, u.y]; }
    }
    V.kills = kills + V.watch.filter((u) => !u.alive).length;
    // 警戒：每殺一人 +2；每個在打我們的巡營兵每秒 +5；被砍醒的兵撐過三秒沒死就大喊一聲 +10
    if (m.i === 1) {
      V.alert += 5 * dt * V.watch.filter((u) => u.alive && u.target && u.target.alive && u.target.team === 0).length;
      for (const u of V.sleep) if (u.alive && !u.asleep && !u.shouted && w.t - (u.wokeAt || w.t) > 3) { u.shouted = true; V.alert += 10; m.line('曹兵', '有人劫營！'); }
      V.alert = Math.min(100, V.alert);
      const o = m.get('alert'); if (o) o.text = `曹營的警戒：${Math.round(V.alert)}%`;
    }
  },
};
